import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'groupBy'
})
export class GroupByPipe implements PipeTransform {
  transform(value: any[], key: string): any[] {
    const groups: { [key: string]: any[] } = {};
    value.forEach(item => {
      if (!groups[item[key]]) {
        groups[item[key]] = [];
      }
      groups[item[key]].push(item);
    });
    return Object.values(groups);
  }
}
